import React from 'react';
import LogoSection from './LogoSection';
import ExploreSection from './ExploreSection';
import ResourcesSection from './ResourcesSection';
import ConnectSection from './ConnectSection';

const FooterLayout = () => {
  return (
    <div className="flex flex-col md:flex-row bg-secondary text-white p-8 mt-20 relative" >
      <div className="flex-grow flex justify-center md:justify-start">
        <LogoSection />
      </div>
      <div className="flex-grow flex lg:justify-center justify-left">
        <ExploreSection />
      </div>
      <div className="flex flex-grow lg:flex-row lg:mt-0 ml-0  mt-[30px] ml-[-38px]">
      <div className="flex-grow flex justify-center">
        <ResourcesSection />
      </div>
      <div className="flex-grow flex justify-center md:justify-end">
        <ConnectSection />
      </div>

      </div>

      {/* <div className="grid grid-cols-2 gap-4 w-full md:flex md:flex-grow md:justify-center">
    <div className="flex justify-center">
      <ResourcesSection />
    </div>
    <div className="flex justify-center">
      <ConnectSection />
    </div>
  </div> */}
    </div>
  );
};

export default FooterLayout;
